<script lang="ts" context="module">
  type CalendarOptions = Array<{
    key: "Apple" | "Google" | "iCal" | "Outlook.com" | "Yahoo";
    value: string;
    label: string | null;
  }>;

  type Timezone = {
    key: "America/Denver";
    value: string;
    label: string | null;
  };

  type Recurrence = {
    FREQ?:
      | StatamicSelect<"DAILY", string>
      | StatamicSelect<"WEEKLY", string>
      | StatamicSelect<"MONTHLY", string>
      | StatamicSelect<"YEARLY", string>
      | null;
    INTERVAL?: string;
    COUNT?: string;
  };

  export function createRRULE(recurrence: Recurrence) {
    if (!recurrence) return null;
    let output = "RRULE:";
    if (recurrence.FREQ) {
      output += `FREQ=${recurrence.FREQ.value};`;
    }
    if (recurrence.INTERVAL) {
      output += `INTERVAL=${recurrence.INTERVAL};`;
    }
    if (recurrence.COUNT) {
      output += `COUNT=${recurrence.COUNT};`;
    }

    // Remove trailing semicolon if present
    return output.replace(/;$/, "");
  }
</script>

<script lang="ts">
  import AddToCalButton from "@components/buttons/AddToCalButton.svelte";
  import type { ButtonProps } from "@components/buttons/Button.svelte";
  /**
   * Props
   */
  export let name: string;
  export let description: string;
  export let options: CalendarOptions;
  export let location: string;
  export let start_date: string;
  export let end_date: string;
  export let start_time: string;
  export let end_time: string;
  export let timezone: Timezone;
  export let recurrence: string | null;
  export let button_text: string;
  export let button_variant: { value: ButtonProps["variant"] };
  export const id: string = "add-to-cal-id";
  export const type: "add_to_calendar" = "add_to_calendar";
</script>

<AddToCalButton
  {name}
  {description}
  options={options.map((option) => option.key)}
  {location}
  startDate={start_date.split("T")[0]}
  endDate={end_date.split("T")[0]}
  startTime={start_time}
  endTime={end_time}
  timeZone={timezone.key}
  recurrence={createRRULE(recurrence)}
  {button_text}
  button_variant={button_variant.value}
/>
